import { render, staticRenderFns } from "./AccountStatView.vue?vue&type=template&id=d10691e4&scoped=true"
import script from "./AccountStatView.vue?vue&type=script&lang=js"
export * from "./AccountStatView.vue?vue&type=script&lang=js"
import style0 from "./AccountStatView.vue?vue&type=style&index=0&id=d10691e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10691e4",
  null
  
)

export default component.exports